import { render, staticRenderFns } from "./renzhi-history.vue?vue&type=template&id=b0c4f27e&scoped=true"
import script from "./renzhi-history.vue?vue&type=script&lang=js"
export * from "./renzhi-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c4f27e",
  null
  
)

export default component.exports